import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CUSTOM_FIELDS_EXPRESSION_SCHEMA_ACTION_TYPE = createNamedActions(
  'system/customFieldsExpressionSchema',
  {
    GET_SCHEMA: 'GET_SCHEMA',
    PATCH_SCHEMA: 'PATCH_SCHEMA',
  },
);
